import React from "react";

interface Props {
  image: string;
  text: string;
  onMore: () => void;
}

const TestimonyCard: React.FC<Props> = ({ image, text, onMore }) => {
  return (
    <div
      className="
        group
        bg-[#F6F7F7]
        rounded-3xl
        shadow-md hover:shadow-xl
        transition-all duration-300

        w-full
        max-w-[260px] sm:max-w-[280px] md:max-w-[300px]

        flex flex-col
        overflow-hidden
        mx-auto
      "
    >
      {/* Image (Portrait / Vertical) */}
      <div className="relative w-full aspect-[3/4] bg-gray-100">
        <img
          src={image}
          alt="testimonial"
          className="
            absolute inset-0
            w-full h-full
            object-cover
            transition-transform duration-500
          "
        />

        {/* soft fade for readability */}
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/25 to-transparent" />
      </div>

      {/* Content */}
      <div className="flex flex-col items-center text-center p-4 sm:p-5 gap-3">
        <p
          className="
            text-gray-600
            text-xs sm:text-sm
            leading-relaxed
            line-clamp-3
          "
        >
          {text}
        </p>

        <button
          onClick={onMore}
          className="
            mt-1
            px-5 py-2
            rounded-full
            bg-primary
            text-white
            text-xs sm:text-sm
            font-medium

            transition-all
            hover:scale-105
            active:scale-95
          "
        >
          Read More
        </button>
      </div>
    </div>
  );
};

export default TestimonyCard;
